import React, { useState, useEffect } from "react";
import { href, useNavigate } from "react-router-dom";
import "../../css/Header.css";

export default function Header({
  leftLogoSrc = "/images/Blue-Head-Logo.png",
  centerLogoSrc = "/images/Invoice-Instagram-Logo.png",
  navItems = [
    { label: "Home", href: "/" },
    { label: "View Archive", href: "/archive" },
    { label: "About", href: "/about" },
    { label: "Ease Your Mind", href: "https://www.youtube.com/watch?v=Jo8jmv4l2IE" },
  ],
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Close the mobile menu when switching to desktop width
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768 && open) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [open]);

  // SPA navigation helper:
  // - Allow Cmd/Ctrl-click to open in new tab
  // - Use navigate() for normal clicks
  const handleNav = (e, to, closeMenu = false) => {
    if (e.metaKey || e.ctrlKey) return; // allow new-tab behavior
    e.preventDefault();
    if (closeMenu) setOpen(false);

    if(to.charAt(0) == '/'){
      navigate(to);
    }else{
      window.open(to);
    }
  };

  return (
    <header className="hdr">
      <div className="hdr-bar">
        {/* Left small square logo */}
        <a
          className="hdr-left"
          href="/"
          aria-label="Go to homepage"
          onClick={(e) => handleNav(e, "/")}
        >
          <img src={leftLogoSrc} alt="Logo" />
        </a>

        {/* Center logo (mobile only) */}
        <a
          className="hdr-center"
          href="/"
          aria-label="Go to homepage"
          onClick={(e) => handleNav(e, "/")}
        >
          <img src={centerLogoSrc} alt="Brand" />
        </a>

        {/* Desktop nav */}
        <nav className="hdr-nav-desktop" aria-label="Primary">
          <ul>
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={(e) => handleNav(e, item.href)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Hamburger (mobile only) */}
        <button
          className="hdr-burger"
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="mobile-menu"
          onClick={() => setOpen((v) => !v)}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" role="img" aria-hidden="true">
            <path d="M3 6h18v2H3zM3 11h18v2H3zM3 16h18v2H3z"></path>
          </svg>
        </button>

        {/* Desktop CTA (floats to the right) */}
        <div className="hdr-cta">
          <button
            type="button"
            className="hdr-cta-btn"
            onClick={() => navigate("/form/intro")}
          >
            Generate Invoice
          </button>
        </div>

      </div>

      {/* Mobile dropdown menu */}
      <nav
        id="mobile-menu"
        className={`hdr-nav-mobile ${open ? "open" : ""}`}
        aria-label="Mobile"
      >
        <ul>
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={(e) => handleNav(e, item.href, true)}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
